import { Grid, GridCol } from "@mantine/core";
import CustomButton from "../../../components/CustomButton";
import { ReactComponent as CaretIcon } from "../../../assets/carentRight.svg";
import { ReactComponent as QuatesIcon } from "../../../assets/Objects.svg";
import { ReactComponent as StarSlide } from "../../../assets/carosel-star-slide.svg";
import { Avatar } from "@mantine/core";
import { Rating } from "@mantine/core";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const testimonials = [
  {
    name: "Yossi M.",
    designation: "Lakewood, NJ",
    message:
      "Our flight from Europe was canceled last minute due to airline scheduling issues. I submitted a claim through Fly n' Claim, and they handled the entire process. We received over €500 per passenger — no stress, no chasing. It was smooth, quick, and very professional.",
  },
  {
    name: "Miriam R.",
    designation: "London, UK",
    message:
      "I wasn't sure I'd qualify for compensation after my flight from New York arrived more than 4 hours late. Fly n' Claim made everything so easy. They explained the process clearly, kept me updated, and I had the money in my account in just a few weeks. I've already recommended them to friends.",
  },
  {
    name: "Kevin S.",
    designation: "Los Angeles, CA",
    message:
      "After being denied boarding due to an overbooked flight, I decided to try Fly n' Claim. They were fast, professional, and took care of all the paperwork. I didn't have to deal with the airline at all. Highly recommended!",
  },
  {
    name: "Sarah K.",
    designation: "Haifa, Israel",
    message:
      "My baggage was delayed for two full days after a long international flight. I submitted my info online and Fly n' Claim took care of the rest. I got reimbursed for my expenses and received the full compensation I was entitled to — no hassle and great communication throughout.",
  },
  {
    name: "Michael T.",
    designation: "Zurich, Switzerland",
    message:
      "We had a missed connection due to a delay on the first leg of our journey. A friend told me about Fly n' Claim, and I'm glad they did. The whole process was simple and they got us paid quickly. It couldn't have been easier.",
  },
  {
    name: "Rose C.",
    designation: "Frequent Flyer",
    message:
      "We were traveling with two toddlers and were denied boarding due to overbooking. It was a nightmare, but Fly n' Claim made sure we were compensated quickly.",
  },
  {
    name: "Avi S.",
    designation: "Brooklyn, NY",
    message:
      "After a 4-hour delay, I used Fly n' Claim to submit a case. They were fast, professional, and took care of all the paperwork. I didn't have to deal with the airline at all. Highly recommended!",
  },
];

const CarouselSection = () => {
  const desktopSwiperRef = useRef(null);
  const mobileSwiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const navigate = useNavigate();

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const slideNext = (isMobile = false) => {
    const swiper = isMobile
      ? mobileSwiperRef.current
      : desktopSwiperRef.current;
    swiper?.slideNext();
  };

  const slidePrev = (isMobile = false) => {
    const swiper = isMobile
      ? mobileSwiperRef.current
      : desktopSwiperRef.current;
    swiper?.slidePrev();
  };

  return (
    <div className="carousel-wrapper">
      <StarSlide className="carousel-star-slide-one" />
      <StarSlide className="carousel-star-slide-two" />

      {/* Desktop View - Keep your original structure */}
      <Grid className="inner-container desktop-wrapper">
        <GridCol span={{ base: 12, lg: 6 }}>
          <div
            style={{ height: "100%", flexDirection: "column", gap: "10px" }}
            className="center"
          >
            <Swiper
              ref={desktopSwiperRef}
              modules={[Navigation, Pagination]}
              slidesPerView={1}
              loop={true}
              onSwiper={(swiper) => {
                desktopSwiperRef.current = swiper;
                handleSlideChange(swiper);
              }}
              onSlideChange={handleSlideChange}
              className="swiper-wrapper-content"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        padding: "30px",
                        backgroundColor: "#fff",
                        borderRadius: "24px",
                        height: "350px",
                      }}
                    >
                      <QuatesIcon />
                      <p className="sub-header">{testimonial.message}</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Avatar alt="its me" size={"lg"} />
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span style={{ fontWeight: "700" }}>
                              {testimonial.name}
                            </span>
                            <span style={{ fontWeight: "400" }}>
                              {testimonial.designation}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Rating value={5} readOnly />
                          <span>5.0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Keep your original progress bar */}
            <div className="progress-container">
              <div className="dots-container">
                {testimonials.map((_, i) => (
                  <span
                    key={i}
                    className={activeIndex === i ? "dot-active" : "dot"}
                    onClick={() => {
                      // For desktop view
                      if (desktopSwiperRef.current) {
                        desktopSwiperRef.current.slideTo(i);
                      }
                      // For mobile view
                      if (mobileSwiperRef.current) {
                        mobileSwiperRef.current.slideTo(i);
                      }
                    }}
                    style={{ cursor: "pointer" }} // Add pointer cursor to indicate clickable
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </GridCol>

        <GridCol span={{ base: 12, lg: 6 }}>
          <div className="carousel-right">
            <div className="carousel-controller-wrapper">
              <button
                onClick={() => slidePrev()}
                style={{ opacity: isBeginning ? "0.1" : 1 }}
                disabled={isBeginning}
                className="control-button"
              >
                <CaretIcon />
              </button>
              <button
                onClick={() => slideNext()}
                disabled={isEnd}
                style={{ opacity: isEnd ? "0.1" : 1 }}
                className="control-button"
              >
                <CaretIcon />
              </button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                alignItems: "flex-start",
              }}
            >
              <h1 className="header" style={{ color: "#FAFDFF" }}>
                What our Clients Say About Us
              </h1>
              <p className="sub-header" style={{ color: "#E6FFF3" }}>
                Thousands of travelers have trusted Fly n' Claim to handle their
                flight compensation claims. Here's what a few of them had to say
              </p>
              <CustomButton
                type="danger"
                btnText={"Read More Reviews"}
                onClick={() => navigate("/review")}
              />
            </div>
          </div>
        </GridCol>
      </Grid>

      {/* Mobile View - Keep your original structure */}
      <Grid className="inner-container mobile-wrapper">
        <GridCol span={{ base: 12, lg: 6 }}>
          <div className="carousel-right">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                alignItems: "flex-start",
              }}
            >
              <h1 className="header" style={{ color: "#FAFDFF" }}>
                What our Clients Say About Us
              </h1>
              <p className="sub-header" style={{ color: "#E6FFF3" }}>
                Thousands of travelers have trusted Fly n' Claim to handle their
                flight compensation claims. Here's what a few of them had to say
              </p>
              <CustomButton
                type="danger"
                btnText={"Read More Reviews"}
                onClick={() => navigate("/review")}
              />
            </div>
          </div>
        </GridCol>

        <GridCol span={{ base: 12, lg: 6 }}>
          <div
            style={{
              height: "100%",
              flexDirection: "column",
              gap: "10px",
              marginTop: "15px",
              paddingBottom: "30px",
            }}
            className="center"
          >
            <Swiper
              ref={mobileSwiperRef}
              modules={[Navigation]}
              slidesPerView={1}
              onSwiper={(swiper) => {
                mobileSwiperRef.current = swiper;
                handleSlideChange(swiper);
              }}
              onSlideChange={handleSlideChange}
              className="swiper-wrapper-content"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        padding: "30px",
                        backgroundColor: "#fff",
                        borderRadius: "24px",
                        height: "380px",
                      }}
                    >
                      <QuatesIcon />
                      <p className="sub-header">{testimonial.message}</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginTop: "auto",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Avatar size={"lg"} alt="its me" />
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span style={{ fontWeight: "700" }}>
                              {testimonial.name}
                            </span>
                            <span style={{ fontWeight: "400" }}>
                              {testimonial.designation}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "10px",
                          }}
                        >
                          <Rating value={5} readOnly />
                          <span>5.0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="carousel-controller-wrapper">
              <button
                onClick={() => slidePrev(true)}
                style={{ opacity: isBeginning ? "0.1" : 1 }}
                disabled={isBeginning}
                className="control-button"
              >
                <CaretIcon />
              </button>
              <button
                onClick={() => slideNext(true)}
                disabled={isEnd}
                style={{ opacity: isEnd ? "0.1" : 1 }}
                className="control-button"
              >
                <CaretIcon />
              </button>
            </div>
          </div>
        </GridCol>
      </Grid>
    </div>
  );
};

export default CarouselSection;
